import { BRAZE_CONTENT_CARDS } from 'common/constants';

export const premiumCamPaywallCard = {
  box__h1: 'Upgrade to access this cam.',
  box__h2: 'Start your free trial to get an ocean view of anywhere, from anywhere.',
  button1__text: 'Upgrade',
  button1__url: '/upgrade',
  name: BRAZE_CONTENT_CARDS.PREMIUM_CAM_PAYWALL,
};

export const rewindPaywallCard = {
  box__h1: 'Relive your session',
  box__h2: "Download your rides - or the waves that got away - then share 'em with your friends",
  button1__text: 'Upgrade',
  button1__url: '/upgrade',
  name: BRAZE_CONTENT_CARDS.PREMIUM_CAM_PAYWALL,
};
